import { ChevronRight } from 'lucide-react';
import { cn } from '@/lib/utils';
import { PersonTileVm } from '@/features/dashboard/bookingChanges/types/BillViewModel.ts';
import PersonTileAmount, { PersonTileAmountSize } from './PersonTileAmount';

interface PersonTileOpenButtonWithPriceProps
  extends React.HTMLAttributes<HTMLDivElement> {
  tile: PersonTileVm;
  isOpen: boolean;
  isEditing: boolean;
  /** Rozwijana treść kafla — przycisk nią steruje (`aria-controls`). */
  panelId: string;
  onToggle: () => void;
  size?: PersonTileAmountSize;
}

/**
 * Kwota i przycisk rozwijania kafla. Przycisk jest jedynym sterowaniem kafla
 * dostępnym z klawiatury — kliknięcie w resztę nagłówka działa tylko dla myszy.
 */
const PersonTileOpenButtonWithPrice = ({
  tile,
  isOpen,
  isEditing,
  panelId,
  onToggle,
  size = 'md',
  className,
  ...props
}: PersonTileOpenButtonWithPriceProps) => (
  <div
    className={cn(
      'ml-auto flex w-full shrink-0 items-center gap-4 sm:w-auto',
      className,
    )}
    {...props}
  >
    <PersonTileAmount
      amount={tile.amount}
      note={tile.amountNote}
      signed={isEditing}
      muted={tile.amountMuted}
      size={size}
    />

    {/* `stopPropagation`: nagłówek kafla przełącza to samo, więc bez tego
        kliknięcie policzyłoby się dwa razy. */}
    <button
      type="button"
      onClick={(event) => {
        event.stopPropagation();
        onToggle();
      }}
      aria-expanded={isOpen}
      aria-controls={panelId}
      className={cn(
        'flex w-full min-w-[96px] cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-[7px] border bg-basic-white px-[11px] py-1.5 text-center text-[13px] font-semibold sm:w-auto',
        isOpen && isEditing
          ? 'border-accent-border-strong text-accent-900'
          : 'border-neutral-200 text-neutral-800',
      )}
    >
      <span>{isOpen ? 'Zwiń' : isEditing ? 'Dostosuj' : 'Rozwiń'}</span>
      <ChevronRight
        aria-hidden
        className={cn(
          'size-3.5 shrink-0 text-neutral-500 transition-transform duration-150',
          isOpen && 'rotate-90',
        )}
      />
    </button>
  </div>
);

export default PersonTileOpenButtonWithPrice;
